import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from "react-router-dom";
import withSizes from 'react-sizes';

import fetcher from '../services/fetcher'
import log from '../services/log';
import useDarkmode from '../hooks/useDarkmode';

import '@rmwc/drawer/styles'

import TradingViewPanel from '../components/TradingViewPanel';

function TradingView(props){
  const history = useHistory()
  const [darkmode] = useDarkmode()
  const [coin, setCoin] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const matchCoin = useRouteMatch({ path: "/tv/:coin",  strict: true });

  async function getCoinDetails(coin){
    setIsLoading(true)
    const coinData = await fetcher.getCoinDetails(coin)
    //log.traceTag('rsi', rsiData)
    if (coinData){
        setIsLoading(false)
        setCoin(coinData)
    }
}

  useEffect(() => {
    if (matchCoin){
      log.traceTag('matchCoin', matchCoin)
      getCoinDetails(matchCoin.params.coin)
    }
  }, []);

  return (
    <div className="p-2 native-page">
      {props.isMobile &&
        <div className="mb-4">
          <button
            type="button"
            className="inline-flex min-h-[38px] items-center justify-center gap-2 rounded-full border px-4 py-2 text-sm font-bold leading-tight shadow-sm transition-colors duration-150 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-1"
            style={{
              borderColor: 'var(--mdc-outlined-button-border-color)',
              backgroundColor: 'var(--mdc-outlined-button-background-color)',
              color: 'var(--mdc-theme-text-primary-on-background)'
            }}
            onClick={() => {
              if (window.history.length > 1) {
                history.goBack();
              } else {
                history.push('/dashboard');
              }
            }}
          >
            <span className="material-icons text-base leading-none">arrow_back</span>
            Back
          </button>
        </div>
      }
      {coin &&
        <TradingViewPanel isPage={true} darkmode={darkmode} coin={coin}></TradingViewPanel>
      }
    </div>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768
})

export default withSizes(mapSizesToProps)(TradingView);
